const AlertMessages = {
  confirmInformations: `
  <p>Thank you for completing your account information! </p>
  <p>To proceed with the next steps of your PERA application, please schedule a video call identity verification <a href='https://calendly.com/pera-support' target='_blank'>here.</a></p>
`,
};

export default AlertMessages;
